// export function validateIDCard(idCard) {
//   // 15位身份证号码的正则表达式
//   const regex15 = /^[1-9]\d{7}(0\d|1[0-2])(0\d|1\d|2\d|3[01])\d{3}$/;
//
//   // 18位身份证号码的正则表达式
//   const regex18 = /^[1-9]\d{5}(19|20)\d{2}(0\d|1[0-2])(0\d|1\d|2\d|3[01])\d{3}(\d|X|x)$/;
//
//   // 判断是否符合15位或18位格式
//   if (!regex15.test(idCard) && !regex18.test(idCard)) {
//     return false;
//   }
//
//   // 如果是15位号码，直接返回true
//   if (idCard.length === 15) {
//     return true;
//   }
//
//   // 校验18位身份证号码的最后一位校验码
//   if (idCard.length === 18) {
//     // 身份证号码前17位的系数
//     const coefficients = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
//     // 身份证号码的校验码
//     const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
//
//     // 计算身份证前17位的加权和
//     let sum = 0;
//     for (let i = 0; i < 17; i++) {
//       sum += idCard[i] * coefficients[i];
//     }
//
//     // 计算校验码
//     const calculatedCheckCode = checkCode[sum % 11];
//
//     // 比较校验码是否一致
//     return idCard[17].toUpperCase() === calculatedCheckCode;
//   }
//
//   return false;
// }

// 简易校验身份证号码
export function validateIDCard(idCard) {
  return /(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(idCard);
}

// 手机号和座机号校验
export function validatePhoneNumber(number) {
  // 中国大陆手机号正则表达式
  const mobileRegex = /^1[3-9]\d{9}$/;

  // 中国大陆座机号正则表达式
  const landlineRegex = /^(0\d{2,3}-?)?\d{7,8}$/;

  // 验证是否是手机号或座机号
  return mobileRegex.test(number) || landlineRegex.test(number);
}
/**
 * 计算当前值占总数的百分比（结果自动限制在 [0, 100] 范围内）
 * @param {number} current - 当前值（非负）
 * @param {number} total - 总数（必须大于 current 且大于 0）
 * @param {number} decimals - 保留的小数位数，默认不处理（返回浮点数）
 * @returns {number} 百分比数值
 */
export function getPercentage(current, total, decimals = null) {
  if (total <= 0) return 0;           // 防止除以零
  let percent = (current / total) * 100;
  // 确保结果在 [0, 100] 之间（虽然题目保证 <100，但增加防御）
  percent = Math.min(100, Math.max(0, percent));
  if (decimals !== null) {
    return Number(percent.toFixed(decimals));
  }
  return percent;
}
/**
 * 周期日期（包含本月）本月/近3月/近6月/近1年，返回当月1号
 * @param {string} baseDate 当天 YYYY-MM-DD
 * @param {string} type month / 3month / 6month / year
 * @returns YYYY-MM-01
 */
export function getRangeStartDate(baseDate, type) {
  const date = new Date(baseDate)
  date.setDate(1) // 锁定当月1号

  switch (type) {
    case 'month':
      // 本月：不往前推
      break
    case '3month':
      // 包含本月 → 往前2个月
      date.setMonth(date.getMonth() - 2)
      break
    case '6month':
      // 包含本月 → 往前5个月
      date.setMonth(date.getMonth() - 5)
      break
    // case 'year':
    //   // 包含本月 → 往前11个月
    //   date.setFullYear(date.getFullYear() - 1)
    //   break
  }

  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}-01`
}
/**
 * 传入任意日期，获取当年1月1日 和 12月31日
 * @param {Date|string} date 任意日期
 * @returns {firstDay, lastDay} YYYY-MM-DD
 */
export function getYearFirstLastDay(date = new Date()) {
  const d = new Date(date)
  const year = d.getFullYear()

  // 本年第一天
  const first = new Date(year, 0, 1)
  // 本年最后一天
  const last = new Date(year + 1, 0, 0)

  // 格式化 YYYY-MM-DD
  const format = (time) => {
    const y = time.getFullYear()
    const m = String(time.getMonth() + 1).padStart(2, '0')
    const day = String(time.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }

  return {
    firstDay: format(first),
    lastDay: format(last)
  }
}
/**
 * 获取往前偏移的【完整自然时间区间】
 * @param {string} start  传入开始时间，如 2026-04-23 00:00:00
 * @param {string} end    传入结束时间，如 2026-04-23 23:59:59
 * @param {string} type   day1 / month1 / month3 / month6 / year1
 * @returns { start, end } 偏移后的完整自然月/年/日
 */
export function getOffsetDateRange(start = '', end = '', type) {
  // ✅ 防错：如果没传日期，默认用今天
  const currDate = new Date(start || new Date())

  // ✅ 防错：无效日期 → 强制用今天
  if (isNaN(currDate.getTime())) {
    currDate = new Date()
  }

  let newStart, newEnd

  switch (type) {
    // 前1天
    case 'day1':
      newStart = new Date(currDate)
      newStart.setDate(newStart.getDate() - 1)
      newStart.setHours(0, 0, 0, 0)

      newEnd = new Date(newStart)
      newEnd.setHours(23, 59, 59, 999)
      break

    // 前1个自然月
    case 'month':
      newStart = new Date(currDate.getFullYear(), currDate.getMonth() - 1, 1)
      newEnd = new Date(currDate.getFullYear(), currDate.getMonth(), 0)
      newStart.setHours(0, 0, 0, 0)
      newEnd.setHours(23, 59, 59, 999)
      break

    // 前3个自然月
    case '3month':
      newStart = new Date(currDate.getFullYear(), currDate.getMonth() - 3, 1)
      newEnd = new Date(currDate.getFullYear(), currDate.getMonth() - 2, 0)
      newStart.setHours(0, 0, 0, 0)
      newEnd.setHours(23, 59, 59, 999)
      break

    // 前6个自然月
    case '6month':
      newStart = new Date(currDate.getFullYear(), currDate.getMonth() - 6, 1)
      newEnd = new Date(currDate.getFullYear(), currDate.getMonth() - 5, 0)
      newStart.setHours(0, 0, 0, 0)
      newEnd.setHours(23, 59, 59, 999)
      break

    // 前一整年
    case 'year':
      const lastYear = currDate.getFullYear() - 1
      newStart = new Date(lastYear, 0, 1)
      newEnd = new Date(lastYear + 1, 0, 0)
      newStart.setHours(0, 0, 0, 0)
      newEnd.setHours(23, 59, 59, 999)
      break

    // 默认今天
    case "1":
      newStart = new Date()
      newStart.setHours(0, 0, 0, 0)
      newEnd = new Date()
      newEnd.setHours(23, 59, 59, 999)
      break
  }

  // 格式化
  const format = (d) => {
    const y = d.getFullYear()
    const M = String(d.getMonth() + 1).padStart(2, '0')
    const D = String(d.getDate()).padStart(2, '0')
    const h = String(d.getHours()).padStart(2, '0')
    const m = String(d.getMinutes()).padStart(2, '0')
    const s = String(d.getSeconds()).padStart(2, '0')
    return `${y}-${M}-${D} ${h}:${m}:${s}`
  }
  // 格式化
  const format1 = (d) => {
    const y = d.getFullYear()
    const M = String(d.getMonth() + 1).padStart(2, '0')
    const D = String(d.getDate()).padStart(2, '0')
    return `${y}-${M}-${D}`
  }
  return {
    start: format(newStart),
    end: format(newEnd),
    start1: format1(newStart),
    end1: format1(newEnd)
  }
}
// 计算结束 - 开始 相差天数
export function getDayDiff(start, end) {
  const s = new Date(start).getTime()
  const e = new Date(end).getTime()
  const day = Math.abs(e - s) / 86400000

  // 首尾都算 +1天
  return Math.floor(day) + 1
}

export function getDateRange(dateStr, n) {
  const date = new Date(dateStr)

  // 往前1天
  const prevDay = new Date(date)
  prevDay.setDate(prevDay.getDate() - 1)

  // 包含当天，所以只往前 n-1 天
  const targetDay = new Date(prevDay)
  targetDay.setDate(targetDay.getDate() - (n - 1))

  // 格式化 YYYY-MM-DD
  const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`

  return {
    prevDate: fmt(prevDay),
    targetDate: fmt(targetDay)
  }
}
/**
 * 判断是否为今天
 * @param {Date|string|number} time 时间
 * @returns {boolean}
 */
export function isToday(time) {
  const now = new Date()
  const target = new Date(time)

  return (
    now.getFullYear() === target.getFullYear() &&
    now.getMonth() === target.getMonth() &&
    now.getDate() === target.getDate()
  )
}